
<script>

   export let initials;
   export let dictWhatEveryLetterStandsFor;

   import {convertAbbreviated,fullstopize} from "../global";

</script>

<abbr title={convertAbbreviated(initials,dictWhatEveryLetterStandsFor)}>{fullstopize(initials.toUpperCase())}</abbr>
